import jwtDecode from "jwt-decode";
import AuthStore from '../stores/AuthStore';

export const decodedToken = (token) => {
    const actualToken = token || getToken();
    if (!actualToken) return null;
    
    try {
        return jwtDecode(actualToken);
    } catch (error) {
        return null;
    }
};


const getToken = () => {
    return AuthStore.getToken();
}

export const isLoggedIn = () => {
    return getToken() !== undefined;
};

// Customer-specific embed styling configuration
const CUSTOMER_EMBED_STYLES = {
    'vg': 'vg-webview',
    // Add future customer embed styles here
};

export const getCustomerEmbedClass = () => {
    try {
        const decoded = decodedToken();
        if (!decoded || !decoded.embed) return null;
        
        return CUSTOMER_EMBED_STYLES[decoded.embed] || null;
    } catch (error) {
        return null;
    }
};